import { useTranslation } from "react-i18next";

import { TEVMeasurement } from "../../shared/interfaces/Result";
import { MeasurementType } from "../../shared/enums/Result";

import { Card } from "../../shared/Card";
import { FormRow } from "../../shared/FormLayout/FormRow";

import { useInternationalFormatters } from "../../shared/helpers/useInternationalFormatters";
import { CopyToClipboard } from "../../shared/CopyToClipboard";
import { useMemo } from "react";

interface TEVMeasurementCardProps {
  measurement: TEVMeasurement;
}

export function TEVMeasurementCard(props: TEVMeasurementCardProps) {
  const { t } = useTranslation();
  const { formatNumber } = useInternationalFormatters();

  const data = useMemo(
    () => [
      {
        label: t("measurements.MeasureDB"),
        value: props.measurement.MeasureDB && formatNumber(props.measurement.MeasureDB, 2),
        textValue: props.measurement.MeasureDB ? formatNumber(props.measurement.MeasureDB, 2) : "",
      },
      {
        label: t("measurements.MeasurePPC"),
        value: props.measurement.MeasurePPC && formatNumber(props.measurement.MeasurePPC, 2),
        textValue: props.measurement.MeasurePPC ? formatNumber(props.measurement.MeasurePPC, 2) : "0",
      },
      {
        label: t("measurements.NoiseLevel"),
        value: props.measurement.NoiseLevel ? formatNumber(props.measurement.NoiseLevel, 2) : "",
      },
      {
        label: t("measurements.TEVInterpretation"),
        value: props.measurement.TEVInterpretation && t(`TEVInterpretation.${props.measurement.TEVInterpretation}`),
        textValue: props.measurement.TEVInterpretation
          ? t(`TEVInterpretation.${props.measurement.TEVInterpretation}`)
          : "",
      },
      {
        label: t("measurements.PhaseReferenceLock"),
        value: props.measurement.PhaseReferenceLock ? t("common.true") : t("common.false"),
      },
      {
        label: t("measurements.PhaseReferenceType"),
        value: props.measurement.PhaseReferenceType && t(`PhaseReferenceType.${props.measurement.PhaseReferenceType}`),
        textValue: props.measurement.PhaseReferenceType
          ? t(`PhaseReferenceType.${props.measurement.PhaseReferenceType}`)
          : "",
      },
    ],
    [t, props.measurement, formatNumber],
  );

  function constructClipboardText() {
    return data.map((d) => `${d.label}, ${d.textValue != null ? d.textValue : d.value}`).join("\n");
  }

  return (
    <Card
      title={t("results.measurementType", {
        measurementType: `$t(MeasurementTypes.${MeasurementType.TEV} )`,
      })}
      className="mb-3"
      action={<CopyToClipboard textToCopy={constructClipboardText()} />}
    >
      {data.map((d) => (
        <FormRow label={d.label} value={d.value} />
      ))}
    </Card>
  );
}
